// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-382bae36] {\n  width: 15px;\n  height: 15px;\n  margin-right: 10px;\n  position: relative;\n  top: -1px;\n}\n.title_cont[data-v-382bae36] {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  font-size: 16px;\n  font-family: PingFangSC-Medium, PingFang SC;\n  font-weight: 500;\n}\n", ""]);
// Exports
module.exports = exports;
